import { combineReducers } from '@reduxjs/toolkit'

import applicationReducer from './application'
import studentApplicationsReducer from './student-applications'
import applicationSettingReducer from './application-setting'
import applicationDashboardReducer from './application-dashboard'
import applicationStatusReducer from './application-status'
import studentEnrollmentReducer from './student-enrollment'
import applicationLotterReducer from './application-lottery'

const combinedReducer = combineReducers({
  application: applicationReducer,
  studentApplications: studentApplicationsReducer,
  applicationSetting: applicationSettingReducer,
  applicationDashboard: applicationDashboardReducer,
  applicationStatus: applicationStatusReducer,
  studentEnrollment: studentEnrollmentReducer,
  applicationLottery: applicationLotterReducer,

})

export default combinedReducer